<template>
  <div class="row shadow-none">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div
          class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              Recieve Stocks
            </button>
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              List of all received stocks
            </p>
          </div>
          <div class="flex gap-[10px] items-center">
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              @click="viewCreate"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
              v-if="hasPermission('Inventory_Create')"
            >
              <i class="feather icon-plus"></i> &nbsp;New Stock
            </button>
          </div>
        </div>
        <div>
          <manageStockTable
            :Inventories="Inventories"
            :loading="loading"
            :confirmDelete="confirmDelete"
            :viewEdit="viewEdit"
          />
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-add" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create New Inventory
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Select Stock
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  @change.prevent="viewAdd"
                  v-model="inventoryCreateType"
                >
                  <option value="product">Product</option>
                  <option value="product-bundle">Product Bundle</option>
                </select>
                <ul v-if="v1.productId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Product Bundle Selection -->
            <div
              v-if="inventoryCreateType === 'product-bundle'"
              class="pb-[16px]"
            >
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Product Bundle
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createInventories.productBundleId"
                >
                  <option
                    v-for="loc in ProductBundles"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }} - {{ loc.unit }}
                  </option>
                </select>
                <ul
                  v-if="v1.productBundleId"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Product Selection -->
            <div v-if="inventoryCreateType === 'product'" class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Product
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createInventories.productId"
                >
                  <option v-for="loc in Products" :key="loc.id" :value="loc.id">
                    {{ loc.name }} - {{ loc.unit }}
                  </option>
                </select>
                <ul v-if="v1.productId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Warehouse Selection -->
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Warehouse
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createInventories.locationId"
                >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v1.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Storage Area Selection -->
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Storage Area
              </label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createInventories.subLocationId"
                >
                  <option
                    v-for="loc in computed_sublocations_create"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v1.subLocationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Cost Per Item -->
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Cost Per Item
              </label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.costPerItem }]"
                  type="number"
                  v-model="createInventories.costPerItem"
                />
                <ul v-if="v1.costPerItem" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <!-- Quantity -->
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Quantity
              </label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.quantity }]"
                  type="number"
                  v-model="createInventories.quantity"
                />
                <ul v-if="v1.quantity" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Inventory Receipt Date</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="date"
                  :max="maxDate"
                  :class="[{ 'is-invalid': v1.receiptDate }]"
                  placeholder="Select a date"
                  v-model="createInventories.receiptDate"
                />
                <ul v-if="v1.receiptDate" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Expiry Date</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="date"
                  :min="maxDate"
                  :class="[{ 'is-invalid': v1.expiryDate }]"
                  placeholder="Select a date"
                  v-model="createInventories.expiryDate"
                />
                <ul v-if="v1.expiryDate" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Expiry date must be greater than inventory received date.
                  </li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Expiry Notification (Days)</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.expiryNotification }]"
                  type="number"
                  v-model="createInventories.expiryNotification"
                />
                <ul
                  v-if="v1.expiryNotification"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product Batch ID</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.productBatchId }]"
                  v-model="createInventories.productBatchId"
                />
                <ul v-if="v1.productBatchId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="create"
            >
              {{ isBusyModal ? "Loading..." : "Add Inventory" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.locationId"
                >
                  <option value="0">All Warehouses</option>
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Depleted Inventory</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.Selectedoption"
                >
                  <option value="0">Hide</option>
                  <option value="1">Show</option>
                  <option value="2">Show Only</option>
                </select>
              </div>
            </div>

            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by product code or product name..."
                  v-model="filter.qry"
                />
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              ></label>
              <div>
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="filter.showForMe"
                  />
                  <span class="custom-control-label">My Inventories Only</span>
                </label>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getInventories"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteStock"
      :isBusy="isBusyModal"
      text="stock"
    />
    <GeneralDeleteMessage
      message="You cannot delete this inventory record because there is a reconcile order transaction history associated with it."
    />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import Pagination from "../components/Pagination.vue";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import manageStockTable from "../components/Inventory/manageStockTable.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsManageStock",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    manageStockTable,
  },

  created() {
    if (!this.hasPermission("Inventory_View")) {
      this.$router.push("/restricted");
    }
    this.getInventories();
    this.getLocations();
    this.getSubLocations();
    this.getProducts();
    this.getProductBundles();
    this.getSystemSettings();
  },

  updated() {
    if (this.$route.params.id && this.Inventories) {
      const inventory = this.Inventories.find(
        (i) => i.id === parseInt(this.$route.params.id)
      );

      if (inventory) this.viewEdit(inventory);
    }
  },

  watch: {
    updateInventories: {
      deep: true,
      immediate: true,

      handler() {
        let filterLocation = this.updateInventories.subLocation.locationId;
        if (filterLocation && filterLocation.length > 0) {
          this.SubLocationsForUpdate = this.SubLocations;
          var newList = this.SubLocationsForUpdate.filter(function(item) {
            let filtered = true;
            if (filterLocation && filterLocation.length > 0) {
              filtered = item.locationId == filterLocation;
            }
            return filtered;
          });
          this.SubLocationsForUpdate = newList;
        }
      },
    },
  },

  data() {
    return {
      filter: {
        status: "0",
        locationId: "0",
        subLocationId: "0",
        qry: "",
        Selectedoption: "0",
        showForMe: false,
      },
      isBusy: false,
      loading: false,
      isBusyModal: false,
      createInventories: {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      updateInventories: {
        costPerItem: null,
        sellPrice: 0,
        initialQuantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
        id: null,
        subLocation: {
          locationId: null,
        },
      },
      editInventories: {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
        id: null,
        subLocation: {
          locationId: null,
        },
      },
      v1: {
        costPerItem: null,
        sellPrice: null,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      v2: {
        costPerItem: null,
        sellPrice: null,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      Inventories: [],
      Locations: [],
      DeleteId: "",
      SubLocations: [],
      SubLocationsForUpdate: [],
      Products: [],
      ProductBundles: [],
      systemSettings: {},
      pageCount: 0,
      count: 0,
      page: 1,
      pageSize: 10,
      hasNext: false,
      hasPrev: false,
      maxDate: "",
      inventoryCreateType: "",
      inventoryEditType: "",
      isModalVisible: false,
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },

    computed_sublocations_create: function() {
      let filterLocation = this.createInventories.locationId;
      let subLocations = this.SubLocations;
      if (filterLocation && filterLocation.length > 0) {
        return this.SubLocations.filter(function(item) {
          let filtered = true;
          if (filterLocation && filterLocation.length > 0) {
            filtered = item.locationId == filterLocation;
          }
          return filtered;
        });
      }
    },

    computed_sublocations_update: function() {
      let filterLocation = this.updateInventories.subLocation.locationId;
      let subLocations = this.SubLocationsForUpdate;
      if (filterLocation && filterLocation.length > 0) {
        return this.SubLocationsForUpdate.filter(function(item) {
          let filtered = true;
          if (filterLocation && filterLocation.length > 0) {
            filtered = item.locationId == filterLocation;
          }
          return filtered;
        });
      }
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },
  methods: {
    reset() {
      this.filter = {
        subLocationId: "0",
        locationId: "0",
        qry: "",
        Selectedoption: "0",
        showForMe: false,
      };
    },
    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },

    async deleteStock() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(`/Inventories/${this.DeleteId}`);
        if (res.ok) {
          this.$toast.success("Stock deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getInventories();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    cancel() {
      const currentStock = this.Inventories.find(
        (p) => p.id === this.editInventories.id
      );
      (currentStock.costPerItem = this.editInventories.costPerItem),
        (currentStock.sellPrice = this.editInventories.sellPrice),
        (currentStock.quantity = this.editInventories.quantity),
        (currentStock.receiptDate = this.editInventories.receiptDate),
        (currentStock.id = this.editInventories.id),
        (currentStock.productId = this.editInventories.productId),
        (currentStock.subLocation.locationId = this.editInventories.locationId),
        (currentStock.subLocationId = this.editInventories.subLocationId),
        (currentStock.expiryDate = this.editInventories.expiryDate),
        (currentStock.productBatchId = this.editInventories.productBatchId),
        (currentStock.expiryNotification = this.editInventories.expiryNotification);
      $("#mod-edit").modal("hide");
    },
    viewCreate() {
      this.inventoryCreateType = "";
      this.createInventories = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: moment().format("YYYY-MM-DD"),
        expiryDate: null,
        productBatchId: null,
        expiryNotification: this.systemSettings
          .defaultProductExpiryNotification,
      };
      this.v1 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      $("#mod-add").modal("show");
    },
    viewAdd() {
      if (!this.inventoryCreateType) {
        alert(
          "Please select a stock type (Product or Product Bundle) to proceed."
        );
        return;
      }
      if (this.inventoryCreateType === "product") {
        this.createInventories.productBundleId = null;
      } else if (this.inventoryCreateType === "product-bundle") {
        this.createInventories.productId = null;
      }
    },
    viewEdit(c) {
      var editValues = {
        costPerItem: c.costPerItem,
        sellPrice: c.sellPrice,
        quantity: c.initialQuantity,
        receiptDate: c.receiptDate,
        productId: c.product.id,
        locationId: c.subLocation.location.id,
        subLocationId: c.subLocation.id,
        id: c.id,
        expiryDate: c.expiryDate,
        productBatchId: c.productBatchId,
        expiryNotification: c.expiryNotification,
      };

      this.editInventories = editValues;
      if (c.product.isBundle) {
        this.inventoryEditType = "product-bundle";
      } else {
        this.inventoryEditType = "product";
      }
      this.updateInventories = c;
      this.updateInventories.receiptDate = moment(String(c.receiptDate)).format(
        "YYYY-MM-DD"
      );

      this.updateInventories.expiryDate = c.expiryDate
        ? moment(String(c.expiryDate)).format("YYYY-MM-DD")
        : "";

      if (!this.updateInventories.expiryNotification) {
        this.updateInventories.expiryNotification = this.systemSettings.defaultProductExpiryNotification;
      }
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },

    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        costPerItem: this.createInventories.costPerItem,
        sellPrice: 0, //this.createInventories.sellPrice,
        quantity: this.createInventories.quantity,
        ...(this.inventoryCreateType == "product" && {
          parentId: this.user.parentId,
        }),
        // parentId: this.user.parentId,
        subLocationId: this.createInventories.subLocationId,
        ...(this.inventoryCreateType == "product" && {
          productId: this.createInventories.productId,
        }),
        ...(this.inventoryCreateType == "product-bundle" && {
          productId: this.createInventories.productBundleId,
        }),
        ...(this.inventoryCreateType == "product-bundle" && {
          hasSerialization: false,
        }),
        // productId: this.createInventories.productId,
        receiptDate: this.createInventories.receiptDate,
        expiryDate: this.createInventories.expiryDate,
        productBatchId: this.createInventories.productBatchId,
        expiryNotification: this.createInventories.expiryNotification,
      };

      if (this.validateCreate()) {
        if (this.inventoryCreateType === "product") {
          await this.$http
            .post("/Inventories/create", data)
            .then(function(res) {
              this.isBusyModal = false;
              this.inventoryCreateType = "";
              $("#mod-add").modal("hide");
              this.$toast.success("Inventory created successfully", {
                icon: false,
                rtl: false,
              });
            })
            .catch(function(err) {
              $("#mod-add").modal("hide");
            });
        } else {
          await this.$http
            .post("/Inventories/createBundle", data)
            .then(function(res) {
              this.isBusyModal = false;
              this.inventoryCreateType = "";
              this.$toast.success("Inventory created successfully", {
                icon: false,
                rtl: false,
              });
            })
            .catch(function() {});
        }

        this.getInventories();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      var isValid = true;

      if (!this.createInventories.costPerItem) {
        this.v1.costPerItem = true;
        isValid = false;
      }

      if (!this.createInventories.quantity) {
        this.v1.quantity = true;
        isValid = false;
      }

      if (!this.createInventories.locationId) {
        this.v1.locationId = true;
        isValid = false;
      }

      if (!this.createInventories.subLocationId) {
        this.v1.subLocationId = true;
        isValid = false;
      }

      if (
        !this.createInventories.productId &&
        this.inventoryCreateType === "product"
      ) {
        this.v1.productId = true;
        isValid = false;
      }

      if (
        !this.createInventories.productBundleId &&
        this.inventoryCreateType === "product-bundle"
      ) {
        this.v1.productBundleId = true;
        isValid = false;
      }

      if (!this.createInventories.receiptDate) {
        this.v1.receiptDate = true;
        isValid = false;
      } else {
        if (this.createInventories.expiryDate) {
          var receivedDate = moment(
            String(this.createInventories.receiptDate)
          ).format("YYYY-MM-DD");
          var expiryDate = moment(
            String(this.createInventories.expiryDate)
          ).format("YYYY-MM-DD");
          if (expiryDate <= receivedDate) {
            this.v1.expiryDate = true;
            isValid = false;
          }
        }
      }

      return isValid;
    },

    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        costPerItem: this.updateInventories.costPerItem,
        sellPrice: 0, //this.updateInventories.sellPrice,
        quantity: this.updateInventories.initialQuantity,
        id: this.updateInventories.id,
        locationId: this.updateInventories.subLocation.locationId,
        subLocationId: this.updateInventories.subLocationId,
        // ...((this.inventoryCreateType == "product" ) && {productId: this.updateInventories.productId}),
        // ...((this.inventoryCreateType == "product-bundle" ) && {productId: this.updateInventories.productBundleId}),
        ...(this.inventoryEditType == "product-bundle" && {
          hasSerialization: false,
        }),
        productId: this.updateInventories.productId,
        receiptDate: this.updateInventories.receiptDate,
        expiryDate: this.updateInventories.expiryDate,
        productBatchId: this.updateInventories.productBatchId,
        expiryNotification: this.updateInventories.expiryNotification,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/Inventories/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            if (this.$route.params.id) this.$router.push("/managestock");
          })
          .catch(function() {});

        this.getInventories();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      this.v2 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      var isValid = true;

      if (!this.updateInventories.costPerItem) {
        this.v2.costPerItem = true;
        isValid = false;
      }

      if (!this.updateInventories.initialQuantity) {
        this.v2.quantity = true;
        isValid = false;
      }

      if (!this.updateInventories.subLocation.locationId) {
        this.v2.locationId = true;
        isValid = false;
      }

      if (!this.updateInventories.subLocationId) {
        this.v2.subLocationId = true;
        isValid = false;
      }

      if (
        !this.updateInventories.productId &&
        this.inventoryCreateType === "product"
      ) {
        this.v2.productId = true;
        isValid = false;
      }

      if (!this.updateInventories.receiptDate) {
        this.v2.receiptDate = true;
        isValid = false;
      } else {
        if (this.updateInventories.expiryDate) {
          var receivedDate = moment(
            String(this.updateInventories.receiptDate)
          ).format("YYYY-MM-DD");
          var expiryDate = moment(
            String(this.updateInventories.expiryDate)
          ).format("YYYY-MM-DD");
          if (expiryDate <= receivedDate) {
            this.v2.expiryDate = true;
            isValid = false;
          }
        }
      }

      return isValid;
    },

    async getInventories() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Inventories/getProductList?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            (this.filter.locationId != "0"
              ? "&locationId=" + this.filter.locationId
              : "") +
            (this.filter.subLocationId != "0"
              ? "&subLocationId=" + this.filter.subLocationId
              : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            "&selectedOption=" +
            this.filter.Selectedoption +
            (this.filter.showForMe != ""
              ? "&showForMe=" + this.filter.showForMe
              : "")
        )
        .then(function(res) {
          this.Inventories = res.body.data;
          this.page = res.body.pageNumber;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    getLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/Locations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    getSubLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/SubLocations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&locationId="
        )
        .then(function(res) {
          this.SubLocations = res.body;
          this.SubLocationsForUpdate = res.body;
        })
        .catch(function() {});
    },
    getProducts() {
      var a = true;

      this.$http
        .get(
          "/Products/getListNoPagingForDistributor?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&excludeProductBundle=" +
            a
        )
        .then(function(res) {
          this.Products = res.body;
        })
        .catch(function() {});
    },

    getProductBundles() {
      this.$http
        .get("/ProductBundle/getList")
        .then(function(res) {
          this.ProductBundles = res.body;
        })
        .catch(function() {});
    },

    async getSystemSettings() {
      this.isBusy = true;

      await this.$http
        .get(
          "/SystemSettings/getList?page=0" +
            "&pageSize=10" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.systemSettings = res.body.data[0];
          this.isBusy = false;
        })
        .catch(function() {});

      this.isBusy = false;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatDateWithTime(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    prev() {
      this.page -= 1;
      this.getInventories();
    },
    next() {
      debugger;
      this.page += 1;
      this.getInventories();
    },
    gotoPage(page) {
      this.page = page;
      this.getInventories();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getInventories();
    },
  },
};
</script>

<style scoped>
#mod-add {
  overflow-y: scroll;
}
</style>
